import React, { useLayoutEffect, useState } from 'react'
import { Global } from '@emotion/core'
import { ThemeProvider, Flex, Box, css } from 'theme-ui'
import theme from '@elegantstack/flow-ui-theme/src/theme'
import pageContextProvider from '@helpers/pageContextProvider'
import { Header } from '../Header/Header'
import { Footer } from '../Footer/Footer'

let isFirstTimeRender = true;

export const Layout = ({ children, pageContext, location }) => {
  let initialColorModeName = 'default';

  if (typeof window !== 'undefined') {
    if (!isFirstTimeRender) {
      initialColorModeName = localStorage.getItem('theme-ui-color-mode');
    }
  }
  const [setThemeObj, setSetThemeObj] = useState({ ...theme, initialColorModeName });

  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      initialColorModeName = localStorage.getItem('theme-ui-color-mode');
      isFirstTimeRender = false;
      setSetThemeObj({ ...theme, initialColorModeName })
    }
  }, []);

  
  return (
    <>
   {setThemeObj&& <ThemeProvider theme={setThemeObj}>
      <pageContextProvider.Provider value={{ pageContext, location }}>
        <Flex variant='layout.layout'>
          <Global styles={css(theme => theme.global)} />
          <Header />
          <Box variant='layout.body'>{children}</Box>
          <Footer />
        </Flex>
      </pageContextProvider.Provider>
    </ThemeProvider>}
    </>
  )
}